import React from 'react'
import PropTypes from 'prop-types'
import { filter } from 'lodash'
import { displayAttribute } from 'utils'

const propTypes = {
  sectionName: PropTypes.string.isRequired,
  companyDetails: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    website: PropTypes.string,
  }),
  contactDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    title: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
  }),
  planEIN: PropTypes.string,
}

const defaultProps = {
  companyDetails: {},
  contactDetails: {},
  planEIN: null,
}
const formatAddress = (sectionData, addressType) => {
  let addressComponents = []
  const orderedSuffixes = ['Street', 'City', 'State', 'PostalCode', 'Country']
  orderedSuffixes.forEach((suffix) => {
    const componentValue = sectionData[addressType + suffix]
    if (!componentValue) return
    addressComponents.push(componentValue)
  })

  return addressComponents.join(', ')
}

function AgreementDetailsPanelContent({
  sectionName,
  companyDetails,
  contactDetails,
  planEIN,
}) {
  const companyAddress = formatAddress(companyDetails, 'billing')
  const contactAddress = formatAddress(contactDetails, 'mailing')
  return (
    <>
      <div className="order-details-container">
        <dl>
          <div className="order-details-column">
            <dt>Company name</dt>
            <dd>{displayAttribute(companyDetails.name)}</dd>
          </div>
          {planEIN && (
            <div className="order-details-column">
              <dt>Employer Identification Number (EIN)</dt>
              <dd>{planEIN}</dd>
            </div>
          )}
          <div className="order-details-column">
            <dt>Company phone</dt>
            <dd>{displayAttribute(companyDetails.phone)}</dd>
          </div>
          <div className="order-details-column">
            <dt>Company website</dt>
            <dd>{displayAttribute(companyDetails.website)}</dd>
          </div>
          <div className="order-details-column">
            <dt>Street address</dt>
            <dd>{displayAttribute(companyAddress)}</dd>
          </div>
        </dl>
      </div>
      <hr />
      <div className="header-container">
        <h3>{sectionName} Contact Details</h3>
      </div>
      <div className="order-details-container">
        <dl>
          <div className="order-details-column">
            <dt>Contact name</dt>
            <dd>
              {displayAttribute(
                filter([
                  contactDetails.firstName,
                  contactDetails.lastName,
                ]).join(' ')
              )}
            </dd>
          </div>
          <div className="order-details-column">
            <dt>Title</dt>
            <dd>{displayAttribute(contactDetails.title)}</dd>
          </div>
          <div className="order-details-column">
            <dt>Phone</dt>
            <dd>{displayAttribute(contactDetails.phone)}</dd>
          </div>
          <div className="order-details-column">
            <dt>Email</dt>
            <dd>{displayAttribute(contactDetails.email)}</dd>
          </div>
          <div className="order-details-column">
            <dt>Street address</dt>
            <dd>{displayAttribute(contactAddress)}</dd>
          </div>
        </dl>
      </div>
    </>
  )
}
AgreementDetailsPanelContent.propTypes = propTypes
AgreementDetailsPanelContent.defaultProps = defaultProps

export default AgreementDetailsPanelContent
